// `Symbol.toPrimitive` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.toprimitive
require('../internals/define-well-known-symbol')('toPrimitive');
